import { useHistory } from "react-router-dom";
import React, { useState } from "react";
import { debug } from "../utils";
import { TableContext } from "../index";
import DeviceManagementTable from "./DeviceManagementTable";
import * as deviceService from "../devices/deviceService";
import LocalPaginationManager from "../view/LocalPaginationManager";
import { ChevronDown } from "lucide-react";

// import DeviceManagementTableHeader from "./DeviceManagementTableHeader";

function DeviceManagementTableSection() {

    const history = useHistory();

    const initTableConfig = {
        selected: [],
        isLoading: true
    }

    const [tableConfig, setTableConfig] = useState(initTableConfig);
    const [collapsed, setCollapsed] = useState(true);

    const changeTableConfig = (config) => {
        debug("Table config changed:", config);
        setTableConfig(config);
    }

    return (
        <TableContext.Provider value={{ config: tableConfig, setConfig: changeTableConfig }}>
            <div key={history.location} className="mb-0">
                <div className="card oct_analysis-card-v2 p-0">
                    <button
                        className="oct_settings-section-header w-100 border-0 p-4"
                        onClick={() => setCollapsed(!collapsed)}
                    >
                        <h3>Devices Management</h3>
                        <ChevronDown
                            className={`oct_icon oct_settings-chevron-v2 ${!collapsed ? 'oct_expanded' : ''}`}
                        />
                    </button>
                    <div className={`oct_settings-section-body ${collapsed ? 'oct_collapsed' : 'oct_expanded'}`}>
                        <div className="card-body">
                            <div className="dataTables_wrapper dt-bootstrap4 no-footer">
                                <div className="row">
                                    <div className="col-sm-12">
                                        <DeviceManagementTable />
                                        <LocalPaginationManager getPage={deviceService.listPageable} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </TableContext.Provider>
    )
}

export default DeviceManagementTableSection;